import { memo } from 'react';

import { DateTime, Flex } from '@/components/core';
import { REFETCH_AGENT_RUN_INTERVAL } from '@/constants';
import { toAgentRunId, useGetAgentRun } from '@/hooks/api';

export type AgentRunImportedCardProps = {
  agentId: string;
  runId: string;
};

const IAgentRunImportedCard = ({ agentId, runId }: AgentRunImportedCardProps) => {
  const { data: run } = useGetAgentRun(toAgentRunId(agentId, runId), {
    fetchFromListCache: true,
    refetchInterval: REFETCH_AGENT_RUN_INTERVAL,
  });

  if (!run) {
    return (
      <Flex className="items-center gap-2">
        <div className="h-3 w-14 animate-pulse rounded-lg bg-gray-200" />
      </Flex>
    );
  }

  return <DateTime date={run.createdTime} />;
};

export const AgentRunImportedCard = memo(IAgentRunImportedCard) as typeof IAgentRunImportedCard;
